export const REMOVE_YOUR_ACCOUNT = 'remove_your_account';
